const ko = {
  // Navigation
  'nav.daily_video': '일상영상',
  'nav.qna_video': '문답영상',
  'nav.growth_record': '성장기록',
  'nav.cancel': '취소',
  'nav.talent_analysis': '재능분석',
  'nav.home': '홈',
  'nav.report': '리포트',
  'nav.education': '맞춤교육',
  'nav.my': '마이',
  'nav.alert.analysis_in_progress.title': '현재 분석 중인 영상이 있어요!',
  'nav.alert.analysis_in_progress.description': '지금은 분석이 진행 중이라,\n다른 영상은 잠시 후에 분석이 가능합니다.\n기존 분석이 완료되면 다시 시도해 주세요.',
  'nav.alert.no_report.title': '리포트를 확인할 수 없습니다!',
  'nav.alert.no_report.description': '아직 리포트가 존재하지 않아요. 아이의 영상을 분석하고, 분석 결과 리포트를 확인해보세요.',
  'nav.alert.no_report.btn': '영상 분석하기',
  'nav.alert.video_limit.title': '추가 영상 업로드 불가',
  'nav.alert.video_limit.description': '12개 영상이 모두 등록되어 있습니다.\n아래의 경우에 따라 진행해주세요.',
  'nav.alert.video_limit.step1_title': '8가지 다중지능 리포트 완성하기',
  'nav.alert.video_limit.step1_desc': '기존 영상을 삭제 → 새로운 영상 추가',
  'nav.alert.video_limit.step2_title': '새로운 리포트로 시작하기',
  'nav.alert.video_limit.step2_desc': "리포트 우측 상단의 더보기 메뉴\n→ '리포트 새로 만들기' 버튼을 클릭",

  // Common
  'common.confirm': '확인',
  'common.cancel': '취소',
  'common.close': '닫기',
  'common.delete': '삭제하기',
  'common.next': '다음',
  'common.register': '등록',
  'common.comment_placeholder': '댓글을 남겨보세요.',
  'common.agree': '동의',
  'common.done': '완료',
  'common.qna': 'Q&A',
  'common.report_abuse': '신고하기',
  'common.general': '일반',
  'common.age': '{{age}}세',
  'common.month': '{{month}}월',
  'common.date_format': '{{month}}월 {{day}}일',
  'common.sort_registration': '등록순',
  'common.sort_latest': '최신순',
  'common.toast_delete_comment_fail': '댓글 삭제에 실패했습니다.',
  'common.toast_delete_post_fail': '게시글 삭제에 실패했습니다.',
  'common.toast_load_fail': '데이터를 불러오는 데 실패했습니다.',
  'common.loading': '로딩 중...',
  'common.time.just_now': '방금 전',
  'common.time.minutes_ago': '{{count}}분 전',
  'common.time.hours_ago': '{{count}}시간 전',
  'common.time.days_ago': '{{count}}일 전',

  // Login & Register
  'login.title_line1': '우리 아이를 이해하는',
  'login.title_line2': 'AI 리포트, 온키즈',
  'login.subtitle': '일상적인 영상에서 발견하는 아이의 재능',
  'login.kakao': '카카오톡으로 시작하기',
  'login.pass': 'PASS로 시작하기',
  'login.kakao_simple': '카카오톡',
  'login.pass_simple': 'PASS',
  'login.pass.title_edit': '회원정보를 수정하기 위해\n본인인증을 진행해주세요.',
  'login.pass.title_signup': '온키즈에 가입하시려면\n본인인증이 필요해요!',
  'login.pass.subtitle': '보안을 위해 인증이 필요합니다.',
  'login.pass.temp_signup': '(로컬용 임시 회원가입)',
  'login.pass.btn_pass': 'PASS로 인증하기',
  'login.pass.btn_kakao': '카카오톡으로 인증하기',
  'login.pass.footer': '본인 확인 후 서비스를\n정상적으로 이용하실 수 있어요.',
  'login.pass.temp_signup_btn': '임시 회원가입',
  'login.pass.temp_signup_toast': '로컬용 임시 회원가입 정보가 부족합니다.',
  'login.pass.alert_already_title': '이미 가입된 계정이 있어요',
  'login.pass.alert_already_desc': '이미 {{type}}으로 로그인한 이력이 있습니다.\n계속하려면 {{type}} 로그인으로 진행해주세요.',
  'login.pass.alert_already_btn': '{{type}} 로그인',
  'login.pass.toast_popup_blocked': '팝업이 차단되어있습니다. 팝업을 허용해주세요.',
  'login.pass.toast_kakao_mobile': '카카오톡 로그인은 모바일에서만 가능합니다.',
  'login.pass.toast_login_fail': '로그인에 실패했습니다. 다시 시도해주세요.',
  'login.splash.title': '우리 아이를 이해하는\nAI 리포트, 온키즈',

  'login.agreement.title': '약관에 동의해주세요',
  'login.agreement.all': '모든 약관에 동의합니다.',
  'login.agreement.age': '[필수] 만 14세 이상 입력',
  'login.agreement.service': '[필수] 서비스 이용약관 동의',
  'login.agreement.privacy': '[필수] 개인정보 처리방침 동의',
  'login.agreement.event': '[선택] 이벤트, 혜택소식 받기',
  'login.agreement.btn_start': '동의하고 온키즈 시작하기',
  'login.agreement.btn_disagree': '약관 동의 안함',
  'login.agreement.error_agree': '약관 동의에 실패했습니다. 다시 시도해주세요.',
  'login.agreement.error_disagree': '약관 부동의에 실패했습니다. 다시 시도해주세요.',

  'login.first_access.skip': '건너뛰기',
  'login.first_access.name_title': '아이 이름을\n입력해 주세요',
  'login.first_access.birth_title': '아이 생년월일을\n입력해 주세요',
  'login.first_access.gender_title': '아이 성별을\n입력해 주세요',
  'login.first_access.gender': '성별',
  'login.first_access.male': '남아',
  'login.first_access.female': '여아',
  'login.first_access.birth': '생년월일',
  'login.first_access.name': '이름',
  'login.first_access.name_placeholder': '이름을 입력해 주세요',
  'login.first_access.btn_register': '아이 등록하기',
  'login.first_access.btn_login': '로그인 바로가기',

  'register.skip': '건너뛰기',
  'register.name_title': '아이 이름을\n입력해 주세요',
  'register.birth_title': '아이 생년월일을\n입력해 주세요',
  'register.gender_title': '아이 성별을\n입력해 주세요',
  'register.gender': '성별',
  'register.male': '남아',
  'register.female': '여아',
  'register.birth': '생년월일',
  'register.name': '이름',
  'register.name_placeholder': '이름을 입력해 주세요',
  'register.submit': '아이 등록하기',
  'register.go_to_login': '로그인 바로가기',
  'register.recording_guide.slide1_1': '영상을 5분 이내로',
  'register.recording_guide.slide1_2': '촬영해 주세요',
  'register.recording_guide.slide2_1': '아이 한 명만 나오도록',
  'register.recording_guide.slide2_2': '영상을 촬영해주세요',
  'register.recording_guide.slide3_1': '표정과 제스처, 목소리가',
  'register.recording_guide.slide3_2': '많이 나오는 영상이 필요해요',

  'register_kids.upload.daily_title': '일상 영상 분석',
  'register_kids.upload.qna_title': '문답 영상 분석',
  'register_kids.upload.skip': '건너뛰기',
  'register_kids.upload.daily_main_title': 'AI 재능 진단을 위해\n아이 영상을 올려주세요',
  'register_kids.upload.qna_main_title': 'AI와 함께 우리 아이의\n생각을 들려주세요',
  'register_kids.upload.daily_sub_title': '바로 우리 아이의 재능을 찾아볼까요?',
  'register_kids.upload.qna_sub_title': '간단한 질문에 답하는 모습만 촬영해 주세요.',
  'register_kids.upload.guide_btn': '어떤 영상을 촬영해야 할까요?',
  'register_kids.upload.btn_upload': '영상 업로드하기',

  // Permissions & Agreements
  'permission.title': '온키즈 이용을 위해\n접근 권한을 허용해 주세요.',
  'permission.camera_mic': '카메라/마이크',
  'permission.camera_mic_desc': '동영상, 이미지 촬영, QR코드 인식 등에 사용',
  'permission.storage': '저장소',
  'permission.storage_desc': '촬영된 파일 저장 및 앱 데이터 관리에 필요',
  'permission.location': '위치',
  'permission.location_desc': '주변 정보 및 서비스 제공에 활용',
  'permission.notification': '알림',
  'permission.notification_desc': '푸시 알림 및 메시지 수신 안내',
  'permission.required': '(필수)',
  'permission.optional': '(선택)',
  'permission.toast_fail': '권한 동의에 실패했습니다. 다시 시도해주세요.',

  'agreement.title': '약관에 동의해주세요',
  'agreement.all_check': '모든 약관에 동의합니다.',
  'agreement.age': '[필수] 만 14세 이상 입력',
  'agreement.service': '[필수] 서비스 이용약관 동의',
  'agreement.privacy': '[필수] 개인정보 처리방침 동의',
  'agreement.event': '[선택] 이벤트, 혜택소식 받기',
  'agreement.submit': '동의하고 온키즈 시작하기',
  'agreement.disagree': '약관 동의 안함',
  'agreement.toast_fail': '약관 동의에 실패했습니다. 다시 시도해주세요.',
  'agreement.toast_disagree_fail': '약관 부동의에 실패했습니다. 다시 시도해주세요.',

  'agreement.age.title': '[필수] 만 14세 이상입니다.',
  'agreement.age.content': '본인은 만 14세 이상이며, 카라아이엔씨의 서비스 이용을 위한 개인정보 수집 및 이용에 동의합니다.\n만 14세 미만 아동은 법정대리인의 동의가 필요하며, 서비스 이용이 제한될 수 있습니다.',
  'agreement.event.title': '[선택] 이벤트, 혜택 소식 받기',
  'agreement.event.content': '마케팅 목적의 정보 수신에 동의합니다.',
  'agreement.event.item1_title': '수신 내용',
  'agreement.event.item1_desc': '신제품 출시, 이벤트, 혜택 안내, 맞춤형 콘텐츠 정보 등',
  'agreement.event.item2_title': '수신 방법',
  'agreement.event.item2_desc': '이메일, 문자, 메신저 등',
  'agreement.event.cookie_desc': '회사는 쿠키(cookie)를 활용하여 이용자의 서비스 사용 형태를 분석하고 맞춤형 정보 제공 및 리마케팅에 활용할 수 있습니다.',
  'agreement.event.cookie_setting': '이용자는 브라우저의 설정을 통해 쿠키 설치를 허용하거나 거부할 수 있습니다.',
  'agreement.event.no_restriction': '동의하지 않아도 서비스 이용에는 제한이 없습니다.',

  'agreement.privacy.title': '[필수] 개인정보 처리방침 동의',
  'agreement.privacy.content': '본인은 카라아이엔씨의 개인정보 처리방침에 동의하며, 아래 내용을 숙지하였습니다.',
  'agreement.privacy.item1_title': '정보주체 권리',
  'agreement.privacy.item1_desc1': '이용자는 회사에 언제든지 개인정보의 열람·정정·삭제를 요청할 수 있으며, 서면·전화·메일(info@karainc.co.kr)을 통해 연락 시 지체 없이 조치됩니다.',
  'agreement.privacy.item1_desc2': '오류 정정 요청 시, 완료 전까지 해당 정보를 이용하거나 제공하지 않습니다.',
  'agreement.privacy.item1_desc3': '이용자의 요청에 따라 해지 또는 삭제된 정보는 관련 법령 및 내부 방침에 따라 처리되며, 다른 용도로는 절대 사용되지 않습니다.',
  'agreement.privacy.item2_title': '영상 및 민감 정보 처리',
  'agreement.privacy.item2_desc1': '아동의 영상 및 비언어 데이터는 분석 목적에 한해 일시적으로 저장되며, 분석 완료 후 일정 기간 보관 후 자동 파기됩니다.',
  'agreement.privacy.item2_desc2': '해당 영상은 서버 내 안전한 영역에 저장되며, 외부 제공은 절대 불가합니다.',
  'agreement.privacy.item3_title': '파기 절차 및 방법',
  'agreement.privacy.item3_desc1': '종이 출력물: 분쇄 또는 소각',
  'agreement.privacy.item3_desc2': '전자파일: 복구 불가능한 기술적 방식으로 완전 삭제',
  'agreement.privacy.item3_desc3': '정보는 목적 달성 후 별도 DB로 분리 저장되며, 일정 보관 후 파기됩니다.',
  'agreement.privacy.item4_title': '개인정보 자동수집(쿠키) 관련',
  'agreement.privacy.item4_desc1': '회사는 쿠키(cookie)를 활용해 이용자의 관심사 및 이용 형태를 파악하여 최적화된 맞춤형 정보를 제공합니다.',
  'agreement.privacy.item4_desc2': '쿠키는 브라우저 설정을 통해 차단 또는 삭제할 수 있으며, 개인 식별 정보를 자동 수집하지 않습니다.',
  'agreement.privacy.item5_title': '보안 조치 (기술적·관리적·물리적 보호)',
  'agreement.privacy.item5_desc1': '침입 차단 시스템, 접근 권한 관리, 서버 이중화, 데이터 암호화 등을 통해 보호 조치 시행',
  'agreement.privacy.item5_desc2': '개인정보 담당자에 한해 접근 권한 부여, 정기 보안 교육 및 보안서약 체계 운영',
  'agreement.privacy.item5_desc3': '보관 장소에 대한 출입 통제 절차 수립 및 물리적 보안 유지',
  'agreement.privacy.item6_title': '개인정보 보호책임자',
  'agreement.privacy.item6_desc1': '이름: 남재규',
  'agreement.privacy.item6_desc2': '연락처: 070-4633-7412 / klunk@malgum.com',
  'agreement.privacy.footer': '※ 본 개인정보처리방침은 시행일로부터 적용되며, 변경사항 발생 시 사전 고지 후 적용됩니다.',

  'agreement.service.title': '[필수] 서비스 이용약관 동의',
  'agreement.service.content': '카라아이엔씨는 상담 및 컨설팅 운영, 맞춤형 콘텐츠 제공, 프로젝트 수행을 위한 시스템 등록 및 민원처리를 위한 목적으로 개인정보를 수집·이용하며, 동의 없이 제3자에게 제공하지 않습니다.',
  'agreement.service.item1_title': '수집 항목',
  'agreement.service.item1_desc1': '필수항목: 이름, 회사명, 휴대전화번호, 이메일 이름',
  'agreement.service.item1_desc2': '선택항목: 부서, 직위, 업종, 전화번호, 보유 도메인',
  'agreement.service.item2_title': '수집 목적',
  'agreement.service.item2_desc1': '상담 및 컨설팅 운영',
  'agreement.service.item2_desc2': '귀사 및 제휴업체의 재화 또는 서비스, 콘텐츠 제공 등 맞춤 서비스 제공',
  'agreement.service.item2_desc3': '프로젝트 수행을 위한 PMS 등록',
  'agreement.service.item2_desc4': '서비스 제공에 관한 계약 이행, 불만 처리, 고지사항 전달, 분쟁 조정 등 민원 처리',
  'agreement.service.item3_title': '수집 방법',
  'agreement.service.item3_desc1': '홈페이지(https://www.karainc.co.kr)의 온라인 상담',
  'agreement.service.item3_desc2': '전화를 통한 상담 신청 등',
  'agreement.service.item4_title': '보유 및 이용 기간',
  'agreement.service.item4_desc1': '수집 목적 달성 시 또는 이용자가 동의를 철회하거나 회사가 폐업하는 경우 지체 없이 파기',
  'agreement.service.item5_title': '제3자 제공',
  'agreement.service.item5_desc1': '원칙적으로 없음',
  'agreement.service.item5_desc2': '단, 법률에 따라 또는 수사상 목적의 공식 요청(수사기관 서면 요청 등)이 있는 경우에만 제공',
  'agreement.service.item6_title': '이용자 의무',
  'agreement.service.item6_desc1': '이용자는 타인의 개인정보 또는 아동 영상을 무단으로 등록해서는 안 되며, 본인은 해당 영상이 보호자 권한 내에서 업로드된 것임에 동의합니다.',
  'agreement.service.item6_desc2': '본 서비스는 만 14세 미만 아동의 비언어 행동 데이터를 기반으로 분석이 이루어지며, AI 분석을 위한 영상 업로드는 부모 또는 법정 보호자의 책임하에 이루어져야 합니다.',
  'agreement.service.footer': '※ 자세한 내용은 [서비스 이용약관] 및 [개인정보처리방침]에서 확인하실 수 있습니다.',

  'welcome.greeting': '{{name}}님, 만나서 반가워요!',
  'welcome.title_line1': '아이의 재능',
  'welcome.title_line2': '을 찾도록',
  'welcome.title_line3': '도와드릴게요',
  'welcome.toast_success': '아이등록에 성공했습니다.',
  'welcome.toast_fail': '아이 등록에 실패했습니다.',
  'welcome.parent_default': '부모',

  // Home
  'home.register_kid': '아이 등록',
  'home.register_kid_desc': '아이 등록하고 서비스 이용하기',
  'home.male': '남아',
  'home.female': '여아',
  'home.completed_date': '완성일자',
  'home.tip': 'TIP',
  'home.login_signup': '회원가입/로그인',
  'home.guide.draft.title': '로그인하고 우리 아이의 잠재력을 확인해 보세요',
  'home.guide.before.title': '영상 분석 후 리포트를 조회할 수 있어요!',
  'home.guide.before.desc': '영상을 올리고 리포트를 만들어보세요!',
  'home.guide.completed.title': '리포트가 완성되었어요! 확인해 보세요',
  'home.guide.inProgress.relationship.title': '대인관계지능에 대한 영상 정보가 필요해요!',
  'home.guide.inProgress.relationship.desc': '다른 사람과 교류 및 활동하는 영상을 올려주세요',
  'home.guide.inProgress.language.title': '언어지능에 대한 영상 정보가 필요해요!',
  'home.guide.inProgress.language.desc': '대화를 하거나 질문에 답하는 영상을 올려주세요',
  'home.guide.inProgress.math.title': '논리수학지능에 대한 영상 정보가 필요해요!',
  'home.guide.inProgress.math.desc': '정보를 계산하고 암기하는 영상을 올려주세요',
  'home.guide.inProgress.physical.title': '신체운동지능에 대한 영상 정보가 필요해요!',
  'home.guide.inProgress.physical.desc': '몸이나 손을 움직이는 활동 영상을 올려주세요',
  'home.guide.inProgress.reflection.title': '자기성찰지능에 대한 영상 정보가 필요해요!',
  'home.guide.inProgress.reflection.desc': '과제를 하거나 감정이 보이는 영상을 올려주세요',
  'home.guide.inProgress.nature.title': '자연친화지능에 대한 영상 정보가 필요해요!',
  'home.guide.inProgress.nature.desc': '동·식물 및 자연과 환경에 대한 영상을 올려주세요',
  'home.guide.inProgress.space.title': '공간지능에 대한 영상 정보가 필요해요!',
  'home.guide.inProgress.space.desc': '퍼즐, 블록 등 물건을 배치하는 영상을 올려주세요',
  'home.guide.inProgress.music.title': '음악지능에 대한 영상 정보가 필요해요!',
  'home.guide.inProgress.music.desc': '노래를 부르거나 음악을 듣는 영상을 올려주세요.',
  'home.select_kid.title': '영상 분석을 진행할\n아이를 선택해 주세요.',
  'home.change_kid.title': '아이 변경',
  'home.change_kid.add_kid': '아이 추가하기',
  'home.alert.register_kid.title': '아이 등록이 필요해요!',
  'home.alert.register_kid.description': '아이를 등록한 뒤 AI 영상 분석이 가능해요. 홈 화면에서 아이를 먼저 등록해주세요.',

  'home.analytics.title': 'AI 분석으로\n아이 재능 알아보기',
  'home.analytics.mission_soon_title': '미션',
  'home.analytics.mission_soon_desc': '은 추후에 오픈될 예정이에요.',
  'home.analytics.daily_title': '일상 영상 분석',
  'home.analytics.daily_desc': '일상 속 모습을 AI가 관찰해요',
  'home.analytics.mission_title': '미션',
  'home.analytics.mission_desc': '부모와 아이가 함께 미션을 진행해요',
  'home.analytics.qna_title': '문답 영상 분석',
  'home.analytics.qna_desc': 'AI가 질문하고 아이가 답변해요',

  'home.more_info.community_title': '커뮤니티',
  'home.more_info.onkiz_talk_title': '온키즈 Talk\n함께 나누는 이야기',
  'home.more_info.onkiz_talk_desc': '육아·교육 공감 커뮤니티',
  'home.more_info.more_onkiz_title': '온키즈 더 알아보기',
  'home.more_info.multi_intelligence_title': '다중지능이론이란?',
  'home.more_info.multi_intelligence_desc': '다중지능이론에 대한 모든 것',
  'home.more_info.ai_tech_title': '온키즈의 AI기술이\n궁금하다면?',
  'home.more_info.ai_tech_desc': '온키즈 AI 기술에 대한 소개',

  'home.onkiz_ai.title': '온키즈 AI',
  'home.onkiz_ai.intro_title': '온키즈 AI 소개',
  'home.onkiz_ai.intro_desc': '온키즈는 다중지능이론을 바탕으로, 아이의 말 · 행동 · 감정 반응을 AI로 분석해 아이의 강점과 약점 지능을 발견해요. 이를 통해 아이의 잠재력을 키우고, 약점을 보완할 수 있도록 도움을 줘요.',
  'home.onkiz_ai.lab_title': '온키즈의 AI 연구소',
  'home.onkiz_ai.lab_desc1': '온키즈는 영재교육 및 재능교육 분야 전문가인 상지대학교 산학협력단 교수진과 함께 다중지능 진단 서비스를 연구하고 개발하고 있어요.',
  'home.onkiz_ai.lab_desc2': '그 뿐만 아니라 인공지능 및 솔루션 관련 특허 6건을 보유하고 있어요. 특히 다중지능 성향을 분석하기 위한 영상, 음성 데이터 분석 시스템 특허를 출원한 바 있어요.',

  'home.multi_intelligence.title': '다중지능이론',
  'home.multi_intelligence.intro_title': '다중지능이론이란?',
  'home.multi_intelligence.intro_desc': '다중지능이론이란, 하버드대학교의 하워드 가드너 교수가 제안한 것으로 인간의 지능이 IQ나 학업 성적 같은 단일한 능력이 아니라, 다양한 지능 간의 상호협력으로 이루어진다고 보는 지능 이론이에요.',
  'home.multi_intelligence.feature_title': '다중지능의 특징',
  'home.multi_intelligence.feature_1': '인간은 누구나 8가지 지능을 가지고 있어요',
  'home.multi_intelligence.feature_2': '지능은 모두 동일하게 중요해요',
  'home.multi_intelligence.feature_3': '8가지 지능은 독립적이지만, 상호 협력하여 작용해요',
  'home.multi_intelligence.feature_4': '개인마다 독특한 프로파일을 보여요',
  'home.multi_intelligence.feature_5': '환경과 경험에 의해 발달이 가능해요',
  'home.multi_intelligence.feature_6': '강점을 강화하고, 강점으로 약점을 보완할 수 있어요',
  'home.multi_intelligence.types_title': '다중지능의 종류',
  'home.multi_intelligence.type_relationship_desc': '대인관계를 잘 이끌어가는 사람들의 능력',
  'home.multi_intelligence.type_language_desc': '말재주와 글솜씨로 세상을 이해하고 만드는 능력',
  'home.multi_intelligence.type_math_desc': '숫자나 규칙, 명제 등을 잘 익히고 만들어내는 능력',
  'home.multi_intelligence.type_physical_desc': '춤, 운동, 연기 등을 쉽게 익히고 창조하는 능력',
  'home.multi_intelligence.type_reflection_desc': '자신의 심리와 정서를 파악하고 표출하는 능력',
  'home.multi_intelligence.type_nature_desc': '환경을 인식하고 분석하는 능력',
  'home.multi_intelligence.type_space_desc': '도형, 그림, 지도, 입체 등을 구상하고 창조하는 능력',
  'home.multi_intelligence.type_music_desc': '음과 박자를 쉽게 느끼고 창조하는 능력',

  // Education
  'education.apply_business': '교육기업신청',
  'education.title_line1': '아이에게 딱 맞는 교육을',
  'education.title_line2': '추천받고 콘텐츠를 둘러봐요',
  'education.subtitle': '한눈에 탐색하는 우리 아이 맞춤 교육',
  'education.get_notified': '오픈 알림 받기',
  'education.alert_title': '푸시 알림 동의',
  'education.alert_desc': '추후에 해당 페이지가 오픈하면\n푸시 알림으로 알려드릴게요!',

  'upload.daily_title': '일상 영상 분석',
  'upload.qna_title': '문답 영상 분석',
  'upload.daily_intro_line1': 'AI 재능 진단을 위해',
  'upload.daily_intro_line2': '아이 영상을 올려주세요',
  'upload.qna_intro_line1': 'AI와 함께 우리 아이의',
  'upload.qna_intro_line2': '생각을 들려주세요',
  'upload.daily_subtitle': '바로 우리 아이의 재능을 찾아볼까요?',
  'upload.qna_subtitle': '간단한 질문에 답하는 모습만 촬영해 주세요.',
  'upload.guide_btn': '어떤 영상을 촬영해야 할까요?',
  'upload.submit_btn': '영상 업로드하기',
  'upload.guide.title': '촬영가이드',
  'upload.guide.intro_line1': '어떤 영상을',
  'upload.guide.intro_line2': '촬영해야 할까요?',
  'upload.guide.desc_line1': '8가지 지능을 분석하기 위해,',
  'upload.guide.desc_line2': '다양한 상황에서의 아이 모습을 촬영해주세요.',
  'upload.guide.tip': '촬영팁',
  'upload.guide.tip_desc1': '한 영상에는 보통 1~2개의 재능만 나타납니다.',
  'upload.guide.tip_desc2': '다양한 상황을 촬영해서 여러 재능을 기록해보세요!',
  'upload.caution.title': '영상 업로드 시 주의사항',
  'upload.caution.item1_title': '촬영',
  'upload.caution.item1_desc': '영상을 5분 이내로\n촬영해 주세요',
  'upload.caution.item2_title': '대상',
  'upload.caution.item2_desc': '아이 한 명만 나오는\n영상이 필요해요',
  'upload.caution.item3_title': '표현',
  'upload.caution.item3_desc': '표정, 목소리가\n잘 드러나게 해주세요',
  'upload.caution.confirm_btn': '확인했어요',

  'upload.intelligence_choice.title': '영상문답 지능선택',
  'upload.intelligence_choice.desc_line1': '아래의 지능 중 1가지를 선택해 주세요.',
  'upload.intelligence_choice.desc_line2': '선택한 지능에 맞는 질문으로 문답 영상을 촬영합니다.',

  'upload.video_handle.toast_camera_fail': '카메라 접근에 실패했습니다. 권한을 확인해주세요.',
  'upload.video_handle.toast_stream_not_found': '카메라 스트림을 찾을 수 없습니다.',
  'upload.video_handle.toast_thumbnail_fail': '썸네일 생성에 실패했습니다. 다시 시도해주세요.',
  'upload.video_handle.toast_no_video': '저장할 영상이 없습니다.',
  'upload.video_handle.record_btn': '영상 촬영하기',
  'upload.video_handle.gallery_btn': '앨범에서 선택',
  'upload.video_handle.title': '동영상 촬영',
  'upload.video_handle.save_alert_title': '영상 저장 안내',
  'upload.video_handle.save_alert_content': '촬영한 영상은 현재 임시 저장 상태입니다. 기기에 저장하시려면 [저장하기] 버튼을 눌러주세요.',
  'upload.video_handle.save_btn': '저장하기',

  'upload.toast_thumbnail_error': '썸네일에 문제가 발생했습니다. 진단 시작하기 버튼을 다시 눌러주세요.',
  'upload.select_rep_image': '대표이미지 선택',
  'upload.start_diagnosis_question_line1': '아래 영상으로',
  'upload.start_diagnosis_question_line2': '재능 진단을 시작할까요?',
  'upload.rep_image_guide': 'AI가 자동 추천한 얼굴이 잘 보이는 장면입니다. 대표 이미지로 사용할 썸네일을 1가지 선택해 주세요.',
  'upload.retake': '재촬영',
  'upload.start_diagnosis': '진단 시작하기',
  'upload.character_title': '대상 아동의 특징',
  'upload.character_desc': '영상에 여러 명의 아동이 등장할 경우, AI가 정확히 분석할 수 있도록 대상 아동의 특징을 간단히 입력해주세요.',
  'upload.character_impression': '인상착의(필수)',
  'upload.character_impression_placeholder': '(예시) 파란색 티셔츠를 입은',
  'upload.character_physical': '신체적 특징(선택)',
  'upload.character_physical_placeholder': '(예시) 키가 큰',
  'upload.character_behavior': '위치/행동적 특징(선택)',
  'upload.character_behavior_placeholder': '(예시) 왼쪽 / 책상에 앉은',
  'upload.character_only_one': '단독 등장',

  'analysis.standby_title': '진행중인 분석이 없습니다.',
  'analysis.pending_explore_btn': '앱 둘러보기',
  'analysis.pending_tooltip_line1': '분석 중에는 앱을 벗어나지 마세요.',
  'analysis.pending_tooltip_line2': '다른 메뉴는 자유롭게 이용 가능합니다.',
  'analysis.pending_title_line1': 'AI가 아이의 잠재된',
  'analysis.pending_title_line2': '재능을 분석하고 있어요.',
  'analysis.pending_caution': '영상에 따라 분석이 최소 5분 정도 소요될 수 있어요!',
  'analysis.success_title_line1': 'AI가 아이의 재능을',
  'analysis.success_title_line2': '분석 완료하였어요!',
  'analysis.success_best_intelligence': '가장 높은지능',
  'analysis.success_top_percent': '상위 {{percent}}%',
  'analysis.success_sub_title': '지능별 분석결과',
  'analysis.success_report_btn': '리포트 확인',
  'analysis.nothing_title_line1': '포착된 재능이 없어요',
  'analysis.nothing_title_line2': '다른 영상을 업로드 해주세요',
  'analysis.error_title_line1': '영상을 분석하지 못했어요',
  'analysis.error_title_line2': '가이드를 다시 확인해 주세요',
  'analysis.re_upload_btn': '재등록',
  'analysis.status.pending': '분석중',
  'analysis.status.success': '분석완료',
  'analysis.status.error': '분석실패',

  // Report
  'report.summary.title': '리포트 요약',
  'report.summary.tooltip': '우수 지능과 보완이 필요한 지능에 대한 점수와\n한줄 평가를 한눈에 볼 수 있어요.',
  'report.summary.score': '{{score}}점',
  'report.summary.intelligence': '{{label}}지능',
  'report.summary.desc_high': '{{label}}지능은 우수하게 나타났으며,',
  'report.summary.desc_low': '{{label}}지능은 보완이 필요해요.',
  'report.summary.excellent': '우수',
  'report.summary.needs_improvement': '보완 필요',
  'report.summary.comparison_previous_tooltip': '설정한 직전 리포트 결과에 대해 가장 많이\n상승/하락한 지능을 확인할 수 있어요.',
  'report.summary.comparison_cumulative_tooltip': '누적된 평균 리포트 결과에 대해 가장 많이\n상승/하락한 지능을 확인할 수 있어요.',
  'report.summary.most_improved': '가장 많이 상승한 지능',
  'report.summary.most_decreased': '가장 많이 하락한 지능',
  'report.summary.previous_short': '이전',
  'report.summary.current_short': '현재',
  'report.summary.average_short': '평균',
  'report.growth.title': '우리 아이 성장 기록 공유',
  'report.change_summary.title': '변화 요약',
  'report.change_summary.tooltip': '리포트 별로 가장 높은 점수를 기록한\n강점 지능을 확인할 수 있어요.',
  'report.score_analysis.title': '아이의 다중지능 점수 분석',
  'report.change_flow.title': '변화 추이',
  'report.change_flow.tooltip': '손가락으로 그래프 화면을 꾹 누르고 좌우로\n이동하면 리포트 간 점수를 확인할 수 있어요.',
  'report.change_flow.empty': '해당 지능이 포착된 리포트가 2건 미만으로\n변화 추이를 분석할 수 없습니다.',
  'report.intelligence_rank.title': '아이의 지능 순위',
  'report.intelligence_rank.age_group': '동일 연령대 아동 중',
  'report.intelligence_rank.top_percent': '상위 {{percent}}%',
  'report.intelligence_rank.belong_to': '에 해당해요.',
  'report.intelligence_rank.kid_label': '아이',
  'report.intelligence_rank.desc_vhigh': '또래 중에서도 매우 우수한 편이에요.\n작은 변화에도 빠르게 반응하며 발달 가능성이 높습니다.',
  'report.intelligence_rank.desc_high': '또래 중에서도 우수한 편이에요.\n적극적인 활동을 통해 더욱 성장할 수 있습니다.',
  'report.intelligence_rank.desc_middle': '또래와 비슷한 수준이에요.\n다양한 경험을 통해 강점을 발견해 나가는 단계입니다.',
  'report.intelligence_rank.desc_low': '조금 더 많은 자극과 경험이 필요해요.\n부모님의 세심한 관찰과 응원이 큰 도움이 됩니다.',
  'report.intelligence_rank.desc_vlow': '발달을 위한 기초를 다지는 단계예요.\n아이의 속도에 맞춰 천천히 이끌어주세요.',
  'report.core.title': '리포트 핵심',
  'report.core.tooltip': '우수 지능과 보완이 필요한 지능에 대한 AI요약과\n지능 포착 순간을 확인해보세요.',
  'report.core.more': '더보기 →',
  'report.core.empty': '리포트 핵심이 없습니다.',
  'report.detail.title': '다중지능별 상세 결과',
  'report.detail.intelligence_detail_btn': '지능상세',
  'report.detail.sub_characteristic_analysis': '세부 특성 분석',
  'report.detail.no_sub_analysis': '세부 특성 분석이 없습니다.',
  'report.select_intelligence.title': '지능선택',
  'report.need_more.title': '분석 필요한 지능',
  'report.need_more.total_count': '/8건',
  'report.video_list.title': '업로드 영상 목록',
  'report.video_list.tooltip': '보통의 경우, 7~8개의 일상 영상으로\n기본 분석이 가능하며, 부족한 지능이 있으면.\n3~4개의 문답 영상으로 보완할 수 있어요.',
  'report.video_list.unit': '건',
  'report.video_list.completed_intelligence': '분석 완료된 지능',
  'report.video_list.toast_report_delete_fail': '리포트 삭제에 실패했습니다. 다시 시도해주세요.',
  'report.video_list.toast_video_delete_fail': '영상 삭제에 실패했습니다. 다시 시도해주세요.',
  'report.video_list.alert_delete_title': '리포트 영상 삭제 안내',
  'report.video_list.alert_delete_content': '삭제된 영상 및 분석 정보는 복구할 수 없습니다.\n정말 삭제하시겠습니까?',
  'report.video_list.alert_delete_success_title': '삭제 완료',
  'report.video_list.alert_delete_success_desc': '영상과 썸네일 삭제가 완료되었습니다.\n리포트는 신규 영상 업로드 시 업데이트됩니다.',
  'report.video_list.alert_delete_fail_title': '지금은 삭제가 어려워요!',
  'report.video_list.alert_delete_fail_desc': '지금은 분석이 진행 중이라,\n분석 중인 영상은 삭제가 어려워요.\n기존 분석이 완료되면 다시 시도해 주세요.',
  'report.header.analysis_result': '분석결과',
  'report.header.growth_change': '성장변화',
  'report.header.alert_comparison_fail_title': '비교 분석이 어려워요',
  'report.header.alert_comparison_fail_desc': '하나의 리포트만으로는 성장 변화 비교가 어려우며, 추가 리포트 생성 시 분석이 가능합니다.',
  'report.header.main_title_suffix': '님의',
  'report.header.main_title_desc': '다중지능 종합 분석 리포트',
  'report.header.last_modified': '마지막 수정일',
  'report.header.guide_title': '종합 리포트 제작 안내',
  'report.header.guide_desc': '8개 지능이 모두 포착되면, 우리 아이 종합 리포트가 제작 완료돼요. 조금 더 다양한 활동 영상을 업로드해 주세요!',
  'report.header.insufficient_title': '포착 지능 수 부족 안내',
  'report.header.insufficient_desc': '포착된 지능이 적어 일부 결과만 보여드려요. 더 정확한 분석을 위해 다양한 활동이 담긴 영상을 추가해 주세요!',
  'report.header.comparison_previous_result': '이전 리포트 비교 결과입니다',
  'report.header.comparison_cumulative_result': '누적 리포트 비교 결과입니다',
  'report.radar.title': '아이의 강·약점 지능 분포',
  'report.observation.observed': '관찰',
  'report.observation.not_observed': '관찰불가',
  'report.presence.exist': '있음',
  'report.presence.not_exist': '없음',
  'report.presence.unreadable': '판독불가',
  'report.comparison.previous': '이전 비교',
  'report.comparison.cumulative': '누적 비교',
  'report.more.create_new': '리포트 새로 만들기',
  'report.more.create_new_guide': '*기존리포트는 완료 처리됩니다.',
  'report.more.delete': '리포트 삭제하기',
  'report.more.share': '리포트 공유하기',
  'report.more.toast_complete_fail': '리포트 완료처리에 실패했습니다. 다시 시도해주세요.',
  'report.more.toast_delete_fail': '리포트 삭제에 실패했습니다. 다시 시도해주세요.',
  'report.more.alert_complete_title': '기존 리포트 완료 안내',
  'report.more.alert_complete_content': '새 리포트를 만들면\n기존 리포트는 완료 처리됩니다.',
  'report.more.alert_delete_title': '리포트 삭제 안내',
  'report.more.alert_delete_content': '리포트를 삭제해도 영상은 유지됩니다.\n영상은 성장기록에서 확인할 수 있습니다.',
  'report.qna.title': '질문하기',
  'report.qna.to_user': '사용자',
  'report.qna.to_expert': '전문가',
  'report.qna.content': '내용',
  'report.qna.private': '비공개',
  'report.qna.answered': '답변완료',
  'report.qna.not_answered': '미답변',
  'report.qna.placeholder': '내용을 작성해 주세요',
  'report.qna.submit': '작성 완료',
  'report.qna.toast_submit_fail': '질문 등록에 실패했습니다.',

  'report.toast.load_fail': '리포트 로드에 실패했습니다. 다시 시도해주세요.',
  'report.toast.detail_fail': '리포트 상세 조회에 실패했습니다. 다시 시도해주세요.',
  'report.toast.previous_fail': '"이전 비교" 데이터 로드에 실패했습니다. 다시 시도해주세요.',
  'report.toast.cumulative_fail': '"누적 비교" 데이터 로드에 실패했습니다. 다시 시도해주세요.',

  'report.empty_case.title': '분석 정보 부족으로 리포트 제공 불가',

  'report.alert.lack_intelligence_title': '지능이 모두 포착되지 않았어요',
  'report.alert.lack_intelligence_desc': '일부 지능이 포착되지 않았어요.\n지능 영역이 중복된 영상을 삭제한 뒤,\n포착되지 않은 지능을 발견할 수 있는\n새 영상으로 교체해 주세요.',

  // Community
  'community.event.title': '이벤트',
  'community.comment_count': '댓글 {{count}}',
  'community.like': '좋아요',
  'community.sort_registration': '등록순',
  'community.sort_latest': '최신순',
  'community.sort_likes': '좋아요순',
  'community.no_comments': '다른 사용자의 답변이 아직 없습니다.\n조금만 기다려주세요.',
  'community.toast_event_load_fail': '이벤트를 불러오는 데 실패했습니다.',
  'community.toast_comment_load_fail': '댓글을 불러오는 데 실패했습니다.',
  'community.toast_comment_create_fail': '댓글 생성에 실패했습니다.',
  'community.qna.total': '전체',
  'community.qna.analysis_report': '분석리포트',
  'community.qna.growth_change': '성장변화',
  'community.qna.expert': '전문가',
  'community.qna.question': '질문',
  'community.qna.user': '사용자',
  'community.qna.private_alert_title': '비공개 게시글이에요',
  'community.qna.private_alert_desc': '비공개 게시글은 작성자 본인만 확인할 수 있어요',
  'community.qna.expert_answer': '전문가 답변',
  'community.qna.consultation_guide': '*전문가와의 1:1 상담 기능은 추후 업데이트 예정입니다.',
  'community.qna.consultation_booking': '1:1 상담 예약 ({{price}}원)',
  'community.qna.consultation_booking_short': '1:1상담예약',
  'community.qna.private_post': '비공개 게시글입니다.',
  'community.qna.toast_load_fail': '게시글과 답변을 불러오는 데 실패했습니다.',
  'community.qna.toast_expert_load_fail': '전문가 답변을 불러오는 데 실패했습니다.',
  'community.qna.toast_like_fail': '좋아요를 등록하는 데 실패했습니다.',
  'community.complaint.title': '신고하기',
  'community.complaint.selector_title': '신고하는 내용을 선택해주세요.',
  'community.complaint.placeholder': '신고 내용을 입력해주세요. (최소 20자, 최대 300자)',
  'community.complaint.submit': '신고하기',
  'community.complaint.success_title': '신고가 접수되었어요',
  'community.complaint.success_desc': '신고해 주셔서 감사합니다.\n신고된 내용은 검토하여 조치할 예정이에요.',
  'community.write.title': '제목',
  'community.write.content': '내용',
  'community.write.title_placeholder': '제목을 작성해 주세요',
  'community.write.content_placeholder': '내용을 작성해 주세요',
  'community.write.qna_placeholder': '문의 내용을 작성해 주세요',
  'community.write.submit': '등록',
  'community.write.complete': '작성 완료',
  'community.write.report': '리포트',
  'community.write.view_date': '조회일',
  'community.write.no_report_selected': '선택된 리포트 없음',
  'community.write.toast_no_report': '리포트가 없습니다. 리포트를 생성해주세요.',
  'community.write.toast_report_load_fail': '리포트 로드에 실패했습니다. 다시 시도해주세요.',
  'community.write.comparison_previous': '이전',
  'community.write.comparison_cumulative': '누적',
  'community.write.previous_report': '이전 리포트',
  'community.freeboard.title': '자유게시판',
  'community.freeboard.toast_load_fail': '자유게시판 리스트를 불러오는 데 실패했습니다.',
  'community.freeboard.detail_toast_load_fail': '자유게시판 데이터를 불러오는 데 실패했습니다.',
  'community.notice.toast_load_fail': '공지사항을 불러오는 데 실패했습니다.',
  'community.write_modal.title': '주제 선택',
  'community.write_modal.freeboard': '자유게시판',
  'community.write_modal.qna': '분석리포트 질문',
  'community.write_modal.growth': '우리 아이 성장 기록',

  // History
  'history.favorite.title': '즐겨찾는 항목',
  'history.favorite.more': '더보기',
  'history.favorite.empty': '즐겨찾기 비디오가 없습니다.',
  'history.favorite.toast_load_fail': '비디오를 불러오는 데 실패했습니다. 다시 시도해주세요.',
  'history.all_videos.title': '전체보기',
  'history.intelligences.title': '재능별로 보기',
  'history.video.intelligence_title': '{{label}}지능',
  'history.video.no_videos': '비디오가 없습니다.',
  'history.video.toast_favorite_added': '비디오가 즐겨찾기에 추가되었습니다.',
  'history.video.toast_favorite_removed': '비디오가 즐겨찾기에서 제거되었습니다.',
  'history.video.toast_favorite_fail': '비디오 즐겨찾기 처리에 실패했습니다.',
  'history.video.toast_favorite_error': '비디오 즐겨찾기 처리 중 오류가 발생했습니다.',
  'history.report_core.empty': '내용이 없습니다.',
  'history.video.favorite': '즐겨찾기',
  'history.video.share': '공유',
  'history.video.ai_report': 'AI 리포트',
  'history.video.share_alert': '공유 기능은 추후에 오픈돼요',

  // My Page
  'my.title': '마이페이지',
  'my.community': '커뮤니티',
  'my.notice': '공지사항',
  'my.notice.item1_title': '개인정보 및 영상 보안 정책 강화 안내',
  'my.notice.item2_title': '고객센터 운영시간 변경 안내',
  'my.notice.item3_title': '영상 업로드 시 주의사항 안내',
  'my.notice.item4_title': 'AI 행동 분석 리포트 정식 오픈 안내',
  'my.notice.item5_title': '온키즈 이용 가이드 안내',
  'my.service_info': '서비스 정보',
  'my.faq': '자주 묻는 질문',
  'my.qna': '1:1 문의',
  'my.qna.private_title': '1:1문의',
  'my.qna.title_label': '제목',
  'my.qna.title_placeholder': '1:1 문의 제목을 작성해 주세요',
  'my.qna.phone_label': '전화번호',
  'my.qna.content_label': '내용',
  'my.qna.content_placeholder': '문의 내용을 작성해 주세요',
  'my.qna.submit_btn': '문의하기',
  'my.qna.toast_success': '1:1 문의가 등록되었습니다.',
  'my.qna.toast_fail': '1:1 문의 등록에 실패했습니다. 다시 시도해주세요.',
  'my.my_posts': '내 작성 목록',
  'my.usage_guide': '이용 안내',
  'my.usage.title': '이용안내',
  'my.usage.privacy_title': '개인정보 및 공개범위',
  'my.usage.item1_title': '1. 수집되는 개인정보 항목',
  'my.usage.item1_dot1': '아동 이름 또는 닉네임, 나이, 성별',
  'my.usage.item1_dot2': '보호자 연락처, 이메일',
  'my.usage.item1_dot3': '분석용 영상 및 리포트 생성 정보',
  'my.usage.item2_title': '2. 수집 목적',
  'my.usage.item2_dot1': '아동 지능 분석 리포트 제공',
  'my.usage.item2_dot2': '서비스 개선 및 통계 활용',
  'my.usage.item2_dot3': '포트 생성 및 사용자 맞춤형 콘텐츠 제공',
  'my.usage.item3_title': '3. 영상 및 리포트 공개 범위',
  'my.usage.item3_dot1': '업로드한 영상과 생성된 리포트는 본인(계정 소유자)만 열람 가능합니다.',
  'my.usage.item3_dot2': '제3자에게 자동 공유되거나 외부에 공개되지 않습니다.',
  'my.usage.item3_dot3': '단, 보호자가 직접 공유 설정한 경우에만 타인 열람 가능',
  'my.usage.item4_title': '4. 저장 및 보관 정책',
  'my.usage.item4_dot1': '영상은 분석 완료 후 일정 기간(예: 30일) 내 자동 삭제됩니다.',
  'my.usage.item4_dot2': '리포트는 계정 유지 시 계속 열람 가능',
  'my.usage.item5_title': '5. 사용자 권리',
  'my.usage.item5_dot1': '언제든지 정보 열람, 수정, 삭제 요청 가능',
  'my.usage.item5_dot2': '영상 및 리포트 삭제 요청 시 즉시 반영',
  'my.usage.item6_title': '6. 보안',
  'my.usage.item6_dot1': '모든 데이터는 암호화되어 안전하게 저장되며, 외부 유출 방지를 위한 기술적 보호조치를 적용하고 있습니다.',
  'my.privacy': '개인정보 및 공개범위',
  'my.company_info': '사업자 정보 확인',
  'my.company.name': '(주)카라아이엔씨',
  'my.company.ceo': '대표자 : 김기쁨',
  'my.company.business_number': '사업자등록번호 : 379-88-02450',
  'my.company.address': '주소 : 서울특별시 동대문구 답십리로38길 19, B동 306호 (답십리동)',
  'my.language_settings': '언어 설정',
  'my.change_language': 'English로 변경',
  'my.kids_report.title': '아이별 리포트 보기',
  'my.kids_report.alert_title': '아이 영상 분석하러 가기',
  'my.kids_report.alert_desc': '재능 분석을 한 뒤 리포트 조회가 가능해요\n아이 영상을 올리고 재능 분석 하실래요?',
  'my.kids_report.alert_btn': '영상 올리기',

  // My Posts
  'my.posts.answered': '답변완료',
  'my.posts.no_answer': '미답변',
  'my.posts.toast_detail_fail': '데이터를 불러오는 데 실패했습니다.',
  'my.posts.toast_comment_load_fail': '댓글을 불러오는 데 실패했습니다.',
  'my.posts.toast_comment_create_fail': '댓글 생성에 실패했습니다.',
  'my.posts.toast_like_fail': '좋아요를 등록하는 데 실패했습니다.',
  'my.posts.toast_delete_fail': '삭제에 실패했습니다.',
  'my.posts.comment_count': '댓글{{count}}',
  'my.posts.no_comments_line1': '다른 사용자의 답변이 아직 없습니다.',
  'my.posts.no_comments_line2': '조금만 기다려주세요.',
  'my.posts.qna_answer_empty': '답변이 없습니다.',
  'my.posts.answer': '답변',
  'my.posts.toast_load_fail': '리스트를 불러오는 데 실패했습니다.',
  'my.posts.user_answer': '사용자 답변',

  'my.profile.edit_title': '프로필 수정',
  'my.profile.parent_edit_title': '내 프로필 수정',
  'my.profile.kid_edit_title': '아이 프로필 수정',
  'my.profile.manage_kids': '아이 관리',
  'my.profile.parent_title': '내 프로필',
  'my.profile.kid_title': '아이 프로필',
  'my.profile.nickname': '닉네임',
  'my.profile.name': '이름',
  'my.profile.birth': '생년월일',
  'my.profile.gender': '성별',
  'my.profile.phone': '휴대전화번호',
  'my.profile.email': '이메일',
  'my.profile.delete_kid': '아이 정보 삭제',
  'my.profile.save': '저장하기',
  'my.profile.toast_img_type_error': 'PNG, JPG, JPEG 형식의 이미지만 업로드 가능합니다.',
  'my.profile.toast_img_size_error': '5MB 이하의 이미지로 올려주세요.',
  'my.profile.toast_save_success': '저장되었습니다.',
  'my.profile.toast_save_fail': '저장에 실패했습니다. 다시 시도해주세요.',
  'my.profile.toast_nickname_required': '닉네임을 입력해주세요.',
  'my.profile.toast_edit_fail': '프로필 수정에 실패했습니다. 다시 시도해주세요.',
  'my.profile.toast_kid_name_required': '아이 이름을 입력해주세요.',
  'my.profile.toast_kid_edit_fail': '아이 프로필 수정에 실패했습니다.',
  'my.profile.toast_delete_analysing': '아이의 영상 분석 중에는 삭제할 수 없습니다.',
  'my.profile.select_photo': '사진 파일 선택',
  'my.profile.delete_alert_title': '아이 정보 삭제 안내',
  'my.profile.delete_alert_desc': '아이 정보를 삭제하면 등록된 모든 영상과\n분석 리포트 정보가 영구 삭제됩니다.\n정말 삭제하시겠습니까?',
  'my.profile.logout': '로그아웃',
  'my.profile.signout': '탈퇴하기',
  'my.profile.auth_required_title': '본인인증이 필요해요',
  'my.profile.auth_required_desc': '이름, 생년월일, 휴대폰번호는\n본인인증 정보로만 수정 가능해요',
  'my.profile.auth_guide': '위 정보는 본인인증 후 수정 가능해요',
  'my.profile.logout_confirm_title': '로그아웃 하시겠어요?',
  'my.profile.signout_confirm_title': '탈퇴하기 전에 확인해 주세요.',
  'my.profile.signout_confirm_desc': '회원탈퇴 시 회원 및 아이의 모든 정보가 삭제됩니다. 탈퇴하시겠어요?',
  'my.profile.info_changed_title': '회원 정보가 변경되었어요',
  'my.profile.info_changed_desc': '본인 인증된 정보로\n회원 정보가 변경되었습니다.',
  'my.profile.toast_signout_fail': '회원 탈퇴에 실패했습니다. 다시 시도해주세요.',
  'my.faq.device_title': '촬영은 어떤 기기로 해야 하나요?',
  'my.faq.device_desc': '온키즈 영상 촬영은 스마트폰만으로도 충분히 가능합니다. 고가의 카메라나 전문 장비는 필요하지 않으며, 가장 중요한 것은 아이의 표정과 행동이 명확하게 보이는 환경입니다.',
  'my.faq.device_tip_title': '※ 촬영 팁:',
  'my.faq.device_tip_1': '밝고 조용한 실내에서 촬영해 주세요.',
  'my.faq.device_tip_2': '카메라는 수평 상태로 고정하고, 흔들림이 없도록 주의해 주세요.',
  'my.faq.device_tip_3': '정면 또는 약간 옆모습이 자연스럽게 담기면 좋습니다.',
  'my.faq.device_tip_4': '영상 길이는 30초~3분 이내가 적절합니다.',
  'my.faq.device_footer': '영상 품질보다 분석 가능한 행동이 잘 포착되었는가가 더 중요합니다.',
  'my.faq.duration_title': '리포트 분석에는 얼마나 걸리나요?',
  'my.faq.duration_desc1': '영상 업로드가 완료된 후, 평균적으로 2~3분 이내에 리포트가 자동 생성됩니다. 분석 시간은 영상의 길이, 화질, 업로드 서버 상태에 따라 약간 차이가 있을 수 있습니다.',
  'my.faq.duration_desc2': '분석이 완료되면, [마이페이지 > 아이별 리포트 보기]에서 즉시 확인하실 수 있습니다.',
  'my.faq.title': '자주 묻는 질문',
  'my.faq.question_suffix': '님,',
  'my.faq.what_curious': '무엇이 궁금하신가요?',

  // Talents
  'talent.language': '언어',
  'talent.music': '음악',
  'talent.physical': '신체운동',
  'talent.math': '논리수학',
  'talent.space': '공간',
  'talent.relationship': '대인관계',
  'talent.reflection': '자기성찰',
  'talent.nature': '자연친화',
  'talent.language.desc': '생각을 말과 글로 표현하는 능력이예요.',
  'talent.music.desc': '음악적 요소를 이해하고 표현하는 능력이예요.',
  'talent.physical.desc': '신체를 정교하게 움직여 표현하는 능력이예요.',
  'talent.math.desc': '논리적으로 사고하고 추론하는 능력이예요.',
  'talent.space.desc': '장면을 머릿속에 잘 떠올려 표현했어요.',
  'talent.relationship.desc': '타인을 이해하고 상호작용하는 능력이예요.',
  'talent.reflection.desc': '자신의 감정과 생각을 이해하는 능력이예요.',
  'talent.nature.desc': '자연에 관심을 갖고 탐구하는 능력이예요.',
  'talent.language.q1': '네가 좋아하는 동화\n하나 말해줄래?\n무슨 내용이야?',
  'talent.language.q2': '아이스크림, 놀이공원, 자전거로\n짧은 이야기를 만들어볼래?',
  'talent.language.q3': '흥부와 놀부 이야기에서,\n놀부는 왜 제비 다리를\n부러뜨렸을까?',
  'talent.music.q1': '가장 좋아하는 노래를 불러줘.',
  'talent.music.q2': '노래를 만든다면\n어떤 악기를 쓰고 싶어?\n여러 개도 괜찮아.',
  'talent.music.q3': '작은 별을 빠르게 불렀다가\n느리게도 불러볼래?',
  'talent.music.q4': '좋아하는 노래를\n엄마/아빠가 배울 수 있게\n알려줘.',
  'talent.physical.q1': '어떤 운동을 좋아해?\n좋아하는 운동 동작\n한 가지를 해볼래?',
  'talent.physical.q2': '친구나 선생님 표정을\n흉내 내볼 수 있어?\n몸짓도 같이 해볼래?',
  'talent.physical.q3': '1. 앞으로 한 발\n2. 옆으로 한 발 3. 위로 점프',
  'talent.physical.q4': '자유롭게 춤을 춰 보자.',
  'talent.math.q1': '규칙을 지키며\n놀이해 본 적 있어?\n그 규칙은 뭐였어?',
  'talent.math.q2': '저녁 식사를 차릴 때\n어던 순서로 준비해?',
  'talent.math.q3': '요구르트 병 3개,\n콜라 캔 2개, 상자 1개로\n뭘 만들 수 있을까?',
  'talent.space.q1': '유치원(또는 자주 가는 곳)\n가는 길에 뭐가 보여?',
  'talent.space.q2': '레고가 있으면 뭘 만들고 싶어?\n어떻게 만들까?',
  'talent.space.q3': '이 방에서 숨바꼭질을 할 때\n어디에 숨으면 잘 안 보일까?',
  'talent.space.q4': '엄마 얼굴이\n어떻게 생겼는지 말해줘.',
  'talent.relationship.q1': '네가 놀부라면\n동생에게 어떻게\n대해주고 싶어?',
  'talent.relationship.q2': '놀이터에서 친구 두 명이\n다투고 있으면\n어떻게 할거야?',
  'talent.relationship.q3': '게임이나 대결을 할 때,\n이기기 위해 같은 팀을\n도아준 적 있어?',
  'talent.relationship.q4': '친구에게 부탁이 있다면\n어떻게 이야기할까?',
  'talent.reflection.q1': '행복한 왕자 이야기에서\n왕자의 입장이라면\n어떤 기분이 들 것 같아?',
  'talent.reflection.q2': '착한 일을 한 적이 있어?\n그 때 기분이 어땠어?',
  'talent.reflection.q3': '하고 싶은 일을 하기 위해\n스스로 어떤 노력을\n했는지 말해줄래?',
  'talent.nature.q1': '좋아하는 동물한테\n1. 어떻게 먹이를 줄거야?\n2. 어떻게 놀아 줄거야?',
  'talent.nature.q2': '나뭇잎, 돌멩이, 나뭇가지가 있다면,\n이것들로 무얼 만들 수 있어?',
  'talent.nature.q3': '화분에 물을 주는 방법을 보여줘.',
  'talent.nature.q4': '식물이 자라면 어떤 모습일까?',

  'talent.language.cat1': '어휘력',
  'talent.language.cat2': '논리적 말하기',
  'talent.language.cat3': '언어 유창성',
  'talent.language.cat4': '이해력 및 설명력',
  'talent.language.cat5': '감정표현',
  'talent.music.cat1': '음악지각',
  'talent.music.cat2': '음악이해',
  'talent.music.cat3': '음악창작',
  'talent.music.cat4': '음악재현',
  'talent.music.cat5': '음악수행',
  'talent.physical.cat1': '신체 조절력',
  'talent.physical.cat2': '신체 표현력',
  'talent.physical.cat3': '순발력과 반응성',
  'talent.physical.cat4': '신체 문제 해결력',
  'talent.math.cat1': '수와 연산',
  'talent.math.cat2': '문제해결력',
  'talent.math.cat3': '규칙 발견',
  'talent.math.cat4': '개념 활용',
  'talent.math.cat5': '논리 추론',
  'talent.space.cat1': '공간 인식',
  'talent.space.cat2': '입체 구성 능력',
  'talent.space.cat3': '방향 위치 활용',
  'talent.space.cat4': '공간 활용',
  'talent.space.cat5': '창의적 시각 표현',
  'talent.relationship.cat1': '공감 능력',
  'talent.relationship.cat2': '협력',
  'talent.relationship.cat3': '갈등 조절',
  'talent.relationship.cat4': '설득 및 이해',
  'talent.reflection.cat1': '감정 인식 및 표현',
  'talent.reflection.cat2': '자기주도성',
  'talent.reflection.cat3': '자기이해',
  'talent.reflection.cat4': '자기성찰',
  'talent.nature.cat1': '동식물 이해 및 돌봄',
  'talent.nature.cat2': '자연 탐구 태도',
  'talent.nature.cat3': '환경 감수성',
  'talent.nature.cat4': '자연 표현',

  'talent.language.guide': '읽은 책에 대해 이야기하거나 함께 대화하는 모습, 단어 놀이를 하는 장면을 촬영합니다.',
  'talent.music.guide': '노래하기, 악기 연주하기, 리듬 맞추기 등 음악적 표현을 담는 것이 좋습니다.',
  'talent.physical.guide': '춤추기, 운동하기, 손동작하기 등 신체 활동을 기록합니다.',
  'talent.math.guide': '숫자를 세거나 퍼즐을 맞추고, 패턴을 찾는 활동을 담습니다.',
  'talent.space.guide': '블록 쌓기, 그림 그리기, 길 찾기 등 공간 지각력을 활용한 활동을 촬영합니다.',
  'talent.relationship.guide': '친구와 함께 놀기, 가족과 대화하기, 협력 게임하기 등 다른 사람과 상호작용하는 모습을 촬영합니다.',
  'talent.reflection.guide': '일기를 쓰고 읽는 장면, 자신의 생각을 말하는 모습, 느낀 감정을 표현하는 활동을 기록합니다.',
  'talent.nature.guide': '식물을 관찰하거나 동물을 보고, 날씨를 살피는 등 자연과 교감하는 활동을 담습니다.',

  // Report Detail Commentary
  'report.detail.definition': '정의 및 개념',
  'report.detail.behavioral_characteristics': '{{age}}세 아동에게서 보이는 행동 특성',
  'report.detail.support_method': '가정에서의 지원 방법',
  'report.detail.precautions': '강점 지능 육성 시 유의점',

  'report.reflection.definition': '자기성찰 지능은 자기 자신의 감정, 생각, 신념, 동기, 기질 등을 깊이 인식하고 이해하며, 이를 바탕으로 자기 삶을 주도적으로 조절하는 능력입니다. 하워드 가드너는 이 지능을 “자기 자신에 대한 정확한 내면적 표상과 자각을 통해 행동을 통제하고 선택할 수 있는 능력”으로 정의했습니다.\n이 지능이 높은 사람은 자신의 강점과 약점을 잘 알고 있으며, 내면의 감정과 욕구를 명확히 인식하고, 자기결정권을 가지고 목표를 설정하며 삶을 계획합니다. 성찰적 사고, 정서적 자기조절, 독립적 학습 능력 등도 여기에 포함됩니다. 성인기에는 상담가, 철학자, 작가, 예술가, 사색가, 연구자 등 내면을 다루는 직업에서 강점이 발휘되며, 어린 시절에는 혼자서도 집중력 있게 놀이하고 자기 감정을 말로 표현하는 경향이 보입니다.',
  'report.reflection.behavior.1': '혼자 놀거나 혼자 공부하는 시간을 잘 견디고 즐깁니다.',
  'report.reflection.behavior.2': '자신의 실수나 실패 경험을 비교적 담담히 받아들이고 교훈으로 삼습니다.',
  'report.reflection.behavior.3': '스스로 목표를 세우고, 계획적으로 행동하려는 모습을 보입니다.',
  'report.reflection.behavior.4': '감정이나 생각을 글이나 그림, 말 등 다양한 방식으로 표현하려고 시도합니다.',
  'report.reflection.behavior.5': '조용히 생각하거나 자신만의 시간을 가지는 것을 필요로 하며, 이를 통해 에너지를 회복합니다.',
  'report.reflection.behavior.6': '타인의 평가보다 자기 내면의 판단이나 신념을 우선시하는 경우가 있습니다.',
  'report.reflection.behavior.7': '감정적으로 힘든 일이 있을 때, 혼자서 정리하거나 스스로 위로하는 모습을 보이기도 합니다.',
  'report.reflection.behavior.8': '규칙에 어긋났을 때 죄책감을 느끼며, 자기 반성을 자연스럽게 하기도 합니다.',
  'report.reflection.behavior.9': '자기만의 취향이나 선호가 확고하며, 이를 타인에게 잘 설명합니다.',
  'report.reflection.behavior.10': '경쟁보다는 자율적인 환경에서 더 좋은 성과를 내기도 합니다.',
  'report.reflection.support.1.title': '감정 일기 및 자기표현 활동 권장',
  'report.reflection.support.1.desc': '그림일기, 감정 카드, ‘오늘의 나’ 기록 등을 통해 자신의 감정을 인식하고 표현하는 훈련을 도와주세요.',
  'report.reflection.support.2.title': '혼자 생각할 시간을 존중하기',
  'report.reflection.support.2.desc': '자기이해가 높은 아이는 때로 혼자만의 시간을 통해 스스로 정리합니다. 이를 간섭하기보다 지켜봐 주세요.',
  'report.reflection.support.3.title': '자기 목표 설정 활동',
  'report.reflection.support.3.desc': '‘이번 주 내가 해보고 싶은 것’, ‘내가 기르고 싶은 습관’ 등을 아이 스스로 정하고 실천하게 하는 경험이 필요합니다.',
  'report.reflection.support.4.title': '부정적 감정 수용하기',
  'report.reflection.support.4.desc': '속상함, 질투, 실망, 수치심 등 부정적 감정도 인정해 주며, 표현할 수 있게 격려하세요.',
  'report.reflection.support.5.title': '다른 지능과 연계된 자기표현 기회 제공',
  'report.reflection.support.5.desc': '음악, 미술, 글쓰기, 신체 활동 등을 통해 내면 감정과 생각을 자연스럽게 표현할 수 있도록 도와주세요.',
  'report.reflection.support.6.title': '정서적 반추의 기회 제공',
  'report.reflection.support.6.desc': '하루를 돌아보는 시간, ‘오늘 기뻤던 일’, ‘다시 하고 싶은 일’ 등을 이야기하며 성찰할 수 있는 습관을 키워 주세요.',
  'report.reflection.precautions': '자기이해지능이 높은 아동은 자신의 감정과 생각을 민감하게 인식하고 내면적으로 깊이 반성하는 경향이 있습니다. 그러나 이러한 특성은 때로 고립을 초래하거나 완벽주의적 성향으로 이어질 수 있습니다. 아이가 혼자 있는 것을 즐긴다고 해서 항상 긍정적인 자기 몰입으로 보기보다는, 타인과의 건강한 상호작용이 이루어지공 있는지 함께 살펴보는 것이 필요합니다.\n또한 자기이해가 높은 아동은 실수에 민감하게 반응하거나 과도한 자기비판에 빠질 수 있으므로, “실패도 과정이야”, “도전한 것 자체가 가치 있어”와 같은 메시지를 반복적으로 전달해 주세요. 내면이 풍부하더라도 언어 표현이 따라주지 않을 수 있으므로 감정 어휘와 자기표현 문장을 익히는 연습도 병행하는 것이 좋습니다. 완벽을 추구하는 경향은 스트레스를 높일 수 있으니, “지금도 충분히 잘하고 있어”라는 따뜻한 피드백을 자주 건네야 합니다. 겉으로 표현하지 않아도 불안이나 스트레스를 느낄 수 있으므로 아이의 놀이, 표정, 말투 등에서 섬세하게 신호를 읽고 개입해 주는 것도 중요합니다. 마지막으로, 성찰이 자기혐오나 회피로 전환되지 않도록 지속적인 지지와 격려로 심리적 안정을 도와주세요.',

  'report.language.definition': '언어지능은 말과 글을 도구로 생각을 정리하고, 타인과 효과적으로 소통하며, 세상을 이해하는 능력입니다. 이 지능이 높은 아동은 이야기를 만들거나 다른 사람의 이야기를 듣는 것을 즐기고, 감정이나 생각을 단어로 표현하는 데 능숙합니다. 하워드 가드너는 언어지능을 “단어를 효과적으로 사용하는 능력”이라고 정의하며, 이야기하기, 설명하기, 말장난, 쓰기, 암기, 표현, 토론 등 언어 중심 활동 전반에서의 민감성과 유창성을 강조합니다.\n이 지능은 단순한 말솜씨를 넘어, 언어를 통해 배우고, 문제를 해결하며, 타인을 설득하거나 이해시키는 능력과 깊은 관련이 있습니다. 작가, 시인, 교사, 방송인, 변호사 등은 모두 언어지능을 적극 활용하는 대표적인 직업입니다.',
  'report.language.behavior.1': '책 읽기를 즐기고, 이야기책을 여러 번 반복해서 읽으려 합니다.',
  'report.language.behavior.2': '새로운 단어에 호기심을 보이며, 어휘력이 발달해 있습니다.',
  'report.language.behavior.3': '말장난, 동시, 운율 있는 문장, 유머 등을 즐깁니다.',
  'report.language.behavior.4': '자신의 경험이나 생각을 또래나 어른에게 말로 자주 설명합니다.',
  'report.language.behavior.5': '이야기나 정보를 듣고 정확히 기억해 전달하는 능력이 뛰어납니다.',
  'report.language.behavior.6': '이야기를 창작하거나, 글쓰기 활동을 흥미로워합니다.',
  'report.language.behavior.7': '말로 감정을 표현하고, 자신의 생각을 또렷하게 전달하려 합니다.',
  'report.language.behavior.8': '낱말 퀴즈, 수수께끼, 언어 게임 등을 즐깁니다.',
  'report.language.behavior.9': '친구들 사이에서도 설명자나 질문자 역할을 맡는 경우가 많습니다.',
  'report.language.behavior.10': '구어뿐 아니라 쓰기 표현에서도 재능을 보입니다.',
  'report.language.support.1.title': '풍부한 언어 환경 제공',
  'report.language.support.1.desc': '아이와 매일 다양한 대화를 나누고, 생각과 감정을 질문해보세요. 아이가 말한 내용을 끝까지 듣고, 적절한 피드백을 주는 것이 중요합니다.',
  'report.language.support.2.title': '창의적인 언어 놀이',
  'report.language.support.2.desc': '말 잇기, 단어 맞추기, 짧은 이야기 만들기, 동화 속 주인공 바꿔 보기 같은 활동은 아이의 언어 능력을 자연스럽게 끌어올립니다.',
  'report.language.support.3.title': '쓰기 활동을 일상화',
  'report.language.support.3.desc': '간단한 일기쓰기, 좋아하는 동물이나 장소 소개글 쓰기 등 부담 없는 쓰기 경험을 자주 제공하세요.',
  'report.language.support.4.title': '미디어 활용 지도',
  'report.language.support.4.desc': '유익한 오디오북, 스토리텔링 영상, 라디오 프로그램 등도 아이의 듣기 언어능력을 자극할 수 있습니다.',
  'report.language.support.5.title': '아이의 질문에 열린 자세로 응답',
  'report.language.support.5.desc': '언어지능 아동은 “왜?”, “어떻게?”라는 질문이 많습니다. 부모가 귀찮아하지 않고 적극적으로 대화에 응해주는 태도가 매우 중요합니다.',
  'report.language.precautions': '언어지능이 높은 아이는 또래보다 말이나 글로 자신의 생각을 잘 표현하고, 어휘력이나 이야기 구성 능력이 뛰어난 경우가 많습니다. 하지만 이 능력만을 두드러지게 키우다 보면 ‘말만 잘하는 아이’라는 오해를 받을 수 있습니다. 언어 표현이 능숙해도 정서 조절이나 실행력이 부족할 수 있기 때문에, 자기성찰이나 자기조절 능력과의 균형 성장이 중요합니다. 또 말하기에만 집중되면 듣기나 공감 능력이 부족해질 수 있으므로, 경청하는 연습이나 질문을 만들어보는 활동도 함께 병행해야 합니다.\n특히 글쓰기나 말하기 대회처럼 성과 중심의 활동에만 몰두하게 되면 표현의 즐거움보다는 평가에 민감해질 수 있습니다. 아이가 표현하는 자체를 즐길 수 있도록 자연스럽게 기회를 제공하고, 실패나 실수 경험도 말이나 글로 풀어볼 수 있도록 도와주세요. 이런 과정은 단순한 언어능력을 넘어서 정서 회복과 자기이해 능력까지 함께 키우는 데 도움이 됩니다.',

  'report.music.definition': '음악 지능은 음의 높낮이, 리듬, 음색, 멜로디, 화성 등 음악적 요소를 인지하고, 이를 창조하거나 표현하고 감상할 수 있는 능력을 말합니다. 하워드 가드너는 이 지능을 “음악적 형식을 인지하고, 표현하며, 변형하거나 평가할 수 있는 능력”으로 정의했습니다.\n이 지능이 높은 사람은 단순히 음악을 좋아하는 것을 넘어, 소리의 구조를 감각적으로 이해하고, 이를 기억·변형·표현하는 능력이 뛰어납니다. 음악을 들을 때 감정을 섬세하게 느끼고, 리듬이나 멜로디를 쉽게 따라하거나창작하려는 성향도 강합니다.\n음악 지능은 단독으로 작용하기보다는 운동 지능(몸의 리듬 표현), 언어 지능(가사 창작), 공간 지능(악보 인지) 등과 함께 통합적으로 활용되는 경우가 많으며, 작곡가, 연주자, 가수, 음악 교사, 사운드 디자이너 등의 직업에서 두드러지게 나타납니다.',
  'report.music.behavior.1': '노래의 멜로디를 잘 기억하며 따라 부릅니다.',
  'report.music.behavior.2': '음정이 틀렸거나 리듬이 어색한 음악을 잘 구별합니다.',
  'report.music.behavior.3': '자연스럽게 흥얼거리거나, 혼잣말처럼 노래를 부르곤 합니다.',
  'report.music.behavior.4': '수업 중 책상이나 의자 등을 리듬감 있게 두드리는 경우가 많습니다.',
  'report.music.behavior.5': '음악을 들을 때 감정적으로 반응하며 눈빛이나 표정이 변합니다.',
  'report.music.behavior.6': '음악에 맞춰 춤추기를 즐기며, 몸으로 리듬을 표현하려 합니다.',
  'report.music.behavior.7': '집에서도 배운 노래를 반복해서 부르거나 변형해서 부릅니다.',
  'report.music.behavior.8': '음악적 활동(합창, 악기 연주, 리듬 놀이 등)을 스스로 찾고 참여하려 합니다.',
  'report.music.behavior.9': '교실에서 나는 소리(예: 종소리, 시계 소리 등)에 민감하게 반응합니다.',
  'report.music.behavior.10': '악기 소리나 자연의 소리(물소리, 새소리 등)를 유독 잘 구분하고 반응합니다.',
  'report.music.support.1.title': '자주 음악 듣기',
  'report.music.support.1.desc': '다양한 장르의 음악(클래식, 국악, 재즈, 동요 등)을 함께 들으며 감상 포인트를 이야기해보세요.',
  'report.music.support.2.title': '음악적 표현 기회 제공',
  'report.music.support.2.desc': '악기(피아노, 우쿨렐레, 리듬악기 등)를 자유롭게 다루게 하거나, 손뼉치기·스카프춤 등 신체 활동과 결합한 음악 활동을 유도해 주세요.',
  'report.music.support.3.title': '가사 창작 놀이',
  'report.music.support.3.desc': '기존 멜로디에 새로운 가사를 붙이거나 가족 이야기를 담은 노래 만들기 등을 통해 창의성을 자극하세요.',
  'report.music.support.4.title': '생활 속 소리 인식 훈련',
  'report.music.support.4.desc': '"이건 무슨 소리지?", "지금 들리는 소리는 어떤 느낌이야?" 식의 질문을 통해 소리에 대한 민감도를 확장해 주세요.',
  'report.music.support.5.title': '음악적 감정 나누기',
  'report.music.support.5.desc': '아이가 음악을 듣고 느끼는 감정을 말로 표현하게 하고, 그 감정을 공감하며 함께 나눠 주세요.',
  'report.music.support.6.title': '리듬 게임과 노래 부르기',
  'report.music.support.6.desc': '반복적이고 간단한 리듬을 따라하거나, 일상 대화를 리듬으로 바꾸는 놀이를 통해 자연스럽게 음악감각을 키울 수 있습니다.',
  'report.music.precautions': '음악지능이 높은 아이는 소리, 리듬, 선율에 민감하며 음악 활동에 몰입하는 경향이 있습니다. 하지만 음악만을 중심으로 아이의 정체성을 규정하기보다는, 다양한 지능의 성장도 함께 살펴야 합니다. 감정을 음악으로 표현하는 데 능숙할 수 있으나, 언어나 행동으로 표현하는 법도 함께 길러야 합니다.\n음악적 재능이 보인다고 해서 조기 실기 교육에 과도하게 집중하기보다는, 즐거운 탐색과 창작의 기회를 충분히 주는 것이 중요합니다. 혼자 음악을 즐긴다고 내성적으로 판단하기보다, 몰입의 특성으로 이해해 주세요. 마지막으로, 음악적 재능을 안정된 습관으로 발전시키기 위해 짧은 시간이라도 집중하고 꾸준히 연습할 수 있도록 도와주는 것이 좋습니다.',

  'report.space.definition': '공간 지능은 시각적·공간적인 정보를 정확히 인식하고 변형하거나 표현할 수 있는 능력입니다. 하워드 가드너는 이 지능을 “시공간적 세계를 정확히 지각하고, 그 지각에 기반하여 재구성하거나 창조할 수 있는 능력”으로 설명했습니다.\n이 지능은 사물의 위치, 크기, 방향, 색상, 형태 등의 관계를 시각적으로 인지하고, 머릿속에서 조작하거나 표현하는 능력을 포함합니다. 단순한 그림 실력 이상의 능력으로, 시각적 상상력, 공간 추론, 도형 조작 능력, 시각-운동 협응력 등이 이에 해당됩니다.\n대표적인 직업군으로는 건축가, 화가, 조각가, 디자이너, 파일럿, 항해사, 외과의사 등이 있으며, 시각적인 정보를 잘 활용하는 학습 방식이 특징입니다.',
  'report.space.behavior.1': '시각적 이미지를 머릿속으로 떠올리고, 그걸 언어로 설명하기도 합니다.',
  'report.space.behavior.2': '그림, 사진, 지도, 도형 등의 시각 자료에 관심이 많으며 학습 시 이를 선호합니다.',
  'report.space.behavior.3': '미술 수업이나 그리기 활동을 즐기고, 색채나 형태 감각이 뛰어납나.',
  'report.space.behavior.4': '수업 중에 종종 공상하거나, 머릿속으로 장면을 상상하는 경향이 있습니다.',
  'report.space.behavior.5': '퍼즐 맞추기, 미로 찾기, 블록 놀이, 레고 조립 등에 흥미와 능력을 보입니다.',
  'report.space.behavior.6': '글보다는 그림에서 더 많은 정보를 얻는 경향이 있으며, 시각 자료로 설명하면 이해가 빠릅니다.',
  'report.space.behavior.7': '공간 구성력이 뛰어나 3차원 건축물이나 구조물을 잘 만들고 즐깁니다.',
  'report.space.behavior.8': '책이나 학습지에 낙서하거나 시각적으로 표현하는 것을 좋아합니다.',
  'report.space.behavior.9': '길 찾기나 방향 감각이 빠르고, 물건을 정리하거나 배열하는 데 흥미를 가집니다.',
  'report.space.behavior.10': '복잡한 그림에서도 세부를 잘 찾아내거나, 변화된 점을 쉽게 알아냅니다.',
  'report.space.support.1.title': '시각 자료를 활용한 학습',
  'report.space.support.1.desc': '말이나 글로 설명하기보다는 그림, 지도, 도식, 플래시카드 등 시각 자료를 함께 활용하면 학습 흥미와 이해도가 높아집니다.',
  'report.space.support.2.title': '조작 활동 지원',
  'report.space.support.2.desc': '블록, 레고, 퍼즐, 종이접기, 종이 모형 만들기 등을 자주 제공해 주세요.',
  'report.space.support.3.title': '공간감각을 자극하는 활동',
  'report.space.support.3.desc': '보물찾기 놀이, 길찾기 미션, 간단한 지도 그리기 등의 놀이를 통해 방향 감각과 공간지각력을 키워 주세요.',
  'report.space.support.4.title': '그림일기/스토리보드 그리기',
  'report.space.support.4.desc': '감정이나 사건을 시각적으로 표현할 기회를 제공하면, 감정 표현과 언어 지능도 함께 발달할 수 있습니다.',
  'report.space.support.5.title': '예술 활동 적극 지원',
  'report.space.support.5.desc': '미술관 나들이, 색깔 놀이, 명화 따라 그리기 등 시각적 감각을 자극하는 활동을 꾸준히 제공해 주세요.',
  'report.space.support.6.title': '감각 통합 활동 병행',
  'report.space.support.6.desc': '고유수용감각, 시각-운동 통합 능력 강화를 위해 밸런스 활동이나 손과 눈의 협응이 필요한 놀(예: 공 던지기, 팽이 돌리기)도 함께 해 주세요.',
  'report.space.precautions': '공간지능이 높은 아이라고 해서 단순히 그림을 잘 그리거나 조립을 잘한다고 모든 사고가 시각 중심이라고 판단하는 것은 바람직하지 않습니다. 시각적 표현과 더불어 언어적 사고력도 함께 점검해야 하며, 말로 설명하는 데 어려움을 느끼는 경우에도 시각 자료를 통해 사고를 명확히 드러낼 수 있으므로, 아이의 표현 방식을 존중해 주는 태도가 필요합니다.\n그림의 완성도나 결과물 중심으로 아이를 비교하거나 평가하기보다는 창의성과 시각적 사고 과정을 중심으로 격려해야 하며, 공간 감각이 불안정한 경우에도 이를 비난하거나 과하게 교정하려 하기보다는 놀이를 통해 자연스럽게 익힐 수 있도록 돕는 것이 효과적입니다.\n또한 공간지능이 강한 아이일수록 언어지능과의 균형이 중요하며, 자신이 만든 시각 자료를 말로 설명하거나 정리하는 활동을 병행하면 인지 발달의 폭이 넓어집니다. 마지막으로, 시각적 자극에 민감한 아이에게는 과도한 영상물보다는 정적인 자료나 실제 사물 관찰 활동 등을 함께 제공해 집중력과 인식력을 안정적으로 길러주는 것이 바람직합니다.',

  'report.relationship.definition': '대인관계 지능은 다른 사람의 감정, 동기, 욕구, 기분, 의도 등을 민감하게 파악하고, 이에 적절하게 반응하며 원만한 관계를 형성하는 능력입니다. 하워드 가드너는 이를 “타인의 기분, 기질, 동기, 의도를 잘 파악하고 구분하는 능력”으로 정의했습니다.\n이 지능이 높은 사람은 타인과 공감하고 소통하며 협력하는 것을 즐기고, 갈등 상황에서 중재자 역할을 잘 수행합니다. 리더십, 협동심, 설득력, 사회적 감수성 등이 여기에 포함됩니다. 성인기에는 정치인, 경영자, 교사, 종교 지도자, 상담가 등 사람을 상대하는 직업에서 재능이 두드러지며, 아이들의 경우에는 친구 사귀기를 좋아하고 타인의 감정을 빠르게 알아채는 특징이 나타납니다.',
  'report.relationship.behavior.1': '또래와 잘 어울리며, 다양한 친구들과의 관계에서 안정적인 모습을 보입니다.',
  'report.relationship.behavior.2': '친구들 사이에서 자연스럽게 리더 역할을 맡거나 중심이 됩니다.',
  'report.relationship.behavior.3': '친구의 고민이나 문제를 들어주고, 스스로 조언을 해주기도 합니다.',
  'report.relationship.behavior.4': '친구의 감정이나 기분을 빨리 알아차리며 공감 능력이 뛰어납니다.',
  'report.relationship.behavior.5': '친구 또는 형제자매와 갈등 상황이 생겨도 대화를 통해 조율하려는 태도를 보입니다.',
  'report.relationship.behavior.6': '동아리, 모임, 놀이 그룹 등 집단 활동에 자발적으로 참여하고 주도합니다.',
  'report.relationship.behavior.7': '누군가를 가르치는 것을 즐기며, 친구에게 설명하거나 알려주는 활동에 자부심을 느깁니다.',
  'report.relationship.behavior.8': '단체 활동에서 중재자 역할을 하거나 다른 사람의 입장을 조율하는 모습을 보입니다.',
  'report.relationship.behavior.9': '집단 안에서 인기가 많으며, 친구를 사귀는 데 큰 어려움이 없습니다.',
  'report.relationship.behavior.10': '새로운 사람이나 상황에 대한 사회적 적응력이 빠릅니다.',
  'report.relationship.support.1.title': '역할 극 및 상황극 활용',
  'report.relationship.support.1.desc': '친구와의 관계, 갈등 상황, 협동 활동 등을 역할 극으로 재현하며 감정 표현과 타인 이해 기술을 키워주세요.',
  'report.relationship.support.2.title': '감정 표현 기회 제공',
  'report.relationship.support.2.desc': '가족 감정 카드 놀이, 오늘 있었던 일 나누기, ‘기분 온도계’ 만들기 등을 통해 자신의 감정을 말로 표현하고 타인의 감정을 이해하는 연습을 도와주세요.',
  'report.relationship.support.3.title': '공동 과제 및 협동 놀이 제공',
  'report.relationship.support.3.desc': '보드게임, 협동 과제(퍼즐 맞추기, 텐트 치기 등)를 통해 협력과 의사소통 능력을 발달시키세요.',
  'report.relationship.support.4.title': '돕는 행동 강화하기',
  'report.relationship.support.4.desc': '가족 내 작은 심부름, 동생 돌보기, 친구 도와주기 등의 기회를 제공하고 이를 격려해주세요.',
  'report.relationship.support.5.title': '사회적 기술에 대한 대화',
  'report.relationship.support.5.desc': '친구를 사귀는 방법, 갈등을 해결하는 방법 등에 대해 부모님과 사례를 공유하고 토론하는 시간을 가지면 사회적 사고력이 향상됩니다.',
  'report.relationship.support.6.title': '봉사 및 사회활동 경험 제공',
  'report.relationship.support.6.desc': '간단한 봉사활동(예: 환경 정화, 나눔 활동 등)을 통해 친사회적 태도와 공감 능력을 키워주세요.',
  'report.relationship.precautions': '대인관계지능이 높은 아동은 타인을 배려하고 돕는 데 능숙하지만, 이로 인해 자신의 욕구를 표현하지 못하고 타인의 기대에 과도하게 맞추려는 태도를 보일 수 있습니다...',

  'report.math.definition': '논리수학 지능은 숫자를 효과적으로 사용하고, 인과관계나 논리적 패턴을 파악하며 추론하는 능력입니다. 하워드 가드너는 이 지능을 “추상적 관계를 이해하고, 이를 사용하여 문제를 논리적으로 분석하며, 과학적으로 해결하는 능력”으로 정의했습니다.\n이 지능이 높은 아동은 사물의 작동 원리에 관심이 많고, 숫자를 다루거나 분류하는 활동을 즐기며, 현상 사이의 인과관계를 밝히는 데 능숙합니다. 수학자, 과학자, 프로그래머, 회계사, 공학자 등의 직업에서 강점을 발휘하는 경우가 많으며, 논리적인 문제 해결 과정을 선호합니다.',
  'report.math.behavior.1': '숫자 세기, 더하기, 빼기 등 수학적 계산에 흥미가 많습니다.',
  'report.math.behavior.2': '사물을 색깔, 모양, 크기 등 기준에 따라 분류하고 순서대로 나열하는 것을 좋아합니다.',
  'report.math.behavior.3': '“왜 그럴까?”라는 질문을 자주 하며 인과관계를 파악하려 합니다.',
  'report.math.behavior.4': '체스, 바둑, 퍼즐, 보드게임 등 전략적인 사고가 필요한 놀이를 즐깁니다.',
  'report.math.behavior.5': '기계나 장난감의 작동 원리에 호기심을 가지고 관찰하거나 분해해보려 합니다.',
  'report.math.behavior.6': '추상적인 상징이나 기호에 관심을 보이고 그 의미를 잘 이해합니다.',
  'report.math.behavior.7': '실험하고 측정하며 결과를 확인하는 과정을 흥미로워합니다.',
  'report.math.behavior.8': '컴퓨터 프로그래밍이나 코딩 개념을 빠르게 습득합니다.',
  'report.math.behavior.9': '논리적인 대화를 즐기고 자신의 주장을 근거를 들어 설명하려 합니다.',
  'report.math.behavior.10': '시간, 거리, 양 등의 측정 개념을 일찍 이해하고 활용합니다.',
  'report.math.support.1.title': '수학적 사고를 자극하는 놀이',
  'report.math.support.1.desc': '주사위 놀이, 도미노, 패턴 블록 등을 통해 수와 형태의 규칙을 자연스럽게 익히게 해주세요.',
  'report.math.support.2.title': '일상 속 과학적 탐구',
  'report.math.support.2.desc': '요리할 때 재료의 양 측정하기, 식물이 자라는 과정 기록하기 등 일상 속에서 가설을 세우고 관찰하는 경험을 제공하세요.',
  'report.math.support.3.title': '분류와 정리 습관',
  'report.math.support.3.desc': '장난감을 용도별로 정리하거나, 빨래를 종류별로 분류하는 활동을 통해 논리적 사고력을 키워 주세요.',
  'report.math.support.4.title': '전략적 게임 권장',
  'report.math.support.4.desc': '규칙이 있는 보드게임을 통해 승패를 떠나 최선의 수를 생각해보는 훈련을 도와주세요.',
  'report.math.support.5.title': '코딩 및 문제 해결 도구 활용',
  'report.math.support.5.desc': '어린이용 코딩 블록이나 로봇 조작 교구를 통해 논리적 순서와 구조를 경험하게 해주세요.',
  'report.math.precautions': '논리수학 지능이 높은 아이는 모든 상황을 인과관계나 논리로만 해석하려 할 수 있어, 때로는 타인의 감정을 이해하거나 공감하는 데 소홀해 보일 수 있습니다. 정답이 명확하지 않은 예술적 활동이나 정서적 대화에서도 가치를 찾을 수 있도록 정서적 자극을 함께 제공하는 것이 중요합니다.',

  'report.physical.definition': '신체운동 지능은 자신의 신체 부위를 조절하여 생각이나 감정을 표현하거나, 손을 사용하여 정교한 물건을 만드는 능력입니다. 하워드 가드너는 이를 “몸 전체나 신체 일부를 사용하여 문제를 해결하거나 산출물을 만들어내는 능력”으로 정의했습니다.\n이 지능이 높은 아동은 몸의 평형 감각, 민첩성, 유연성이 뛰어나고, 신체적 활동을 통해 정보를 습득하는 것을 선호합니다. 운동선수, 무용가, 배우, 외과의사, 공예가 등에서 이 지능이 두드러지며, 직접 만지고 움직이는 체험 중심의 학습에서 뛰어난 성과를 보입니다.',
  'report.physical.behavior.1': '달리기, 뛰기, 오르기 등 활동적인 신체 놀이를 매우 즐깁니다.',
  'report.physical.behavior.2': '음악에 맞춰 몸을 움직이거나 춤추는 것에 소질이 있습니다.',
  'report.physical.behavior.3': '눈과 손의 협응력이 좋아 공 던지기, 받기 등을 잘합니다.',
  'report.physical.behavior.4': '도구를 사용하여 무언가를 만들거나 조립하는 손재주가 뛰어납니다.',
  'report.physical.behavior.5': '가만히 앉아 있기보다 몸을 움직이며 에너지를 발산하는 것을 좋아합니다.',
  'report.physical.behavior.6': '운동 기술을 빠르게 습득하고 자신의 신체를 정교하게 조절합니다.',
  'report.physical.behavior.7': '연기나 흉내 내기를 통해 감정이나 상황을 몸으로 잘 표현합니다.',
  'report.physical.behavior.8': '실내보다는 야외 활동을 선호하며 지치지 않는 체력을 보입니다.',
  'report.physical.behavior.9': '촉각이 발달하여 사물을 만져보고 탐색하는 과정을 즐깁니다.',
  'report.physical.behavior.10': '균형 감각이 뛰어나 평균대 걷기나 킥보드, 자전거 타기에 능숙합니다.',
  'report.physical.support.1.title': '다양한 스포츠 경험',
  'report.physical.support.1.desc': '수영, 태권도, 축구, 발레 등 다양한 신체 활동을 통해 대근육과 소근육을 고루 발달시켜 주세요.',
  'report.physical.support.2.title': '체험 중심 학습',
  'report.physical.support.2.desc': '눈으로만 보는 학습보다 직접 만들고 조작하며 배우는 기회를 많이 제공하세요.',
  'report.physical.support.3.title': '예술적 신체 표현',
  'report.physical.support.3.desc': '연극 놀이나 무용을 통해 자신의 감정을 신체로 표현하는 창의적 활동을 도와주세요.',
  'report.physical.support.4.title': '소근육 발달 놀이',
  'report.physical.support.4.desc': '종이접기, 점토 놀이, 바느질 놀이 등을 통해 정교한 조작 능력을 길러 주세요.',
  'report.physical.support.5.title': '야외 활동 시간 확보',
  'report.physical.support.5.desc': '매일 일정 시간 이상 밖에서 마음껏 뛰어놀며 에너지를 발산할 수 있는 환경을 만들어 주세요.',
  'report.physical.precautions': '신체운동 지능이 높은 아이는 활동량이 많아 산만하다는 오해를 받기 쉽습니다. 정적인 환경에서 집중력을 요구하기보다, 학습 과정에 움직임을 결합하는 창의적인 접근이 필요합니다. 또한 경쟁적인 스포츠 상황에서 지나치게 승패에 집착하지 않도록 페어플레이 정신과 정서적 조절을 함께 지도해 주세요.',

  'report.nature.definition': '자연친화 지능은 식물, 동물, 지질, 기후 등 자연 세계를 관찰하고 이해하며 분류하는 능력입니다. 하워드 가드너가 여덟 번째로 추가한 지능으로, “자연의 패턴을 인식하고 생물체에 대한 민감성을 가지며 환경을 보존하려는 경향”을 포함합니다.\n이 지능이 높은 아동은 자연 속에서 심리적 안정을 느끼며, 생명체의 특징을 정확히 파악하고 돌보는 데 재능이 있습니다. 생물학자, 수의사, 원예가, 조경사, 환경 운동가 등 자연과 밀접한 관련이 있는 직업에서 두드러진 능력을 보입니다.',
  'report.nature.behavior.1': '동식물에 대한 관심이 많고 이름이나 특징을 잘 기억합니다.',
  'report.nature.behavior.2': '야외에서 곤충이나 식물을 관찰하는 활동에 몰입합니다.',
  'report.nature.behavior.3': '동물을 무서워하기보다 친근하게 느끼고 돌보려 노력합니다.',
  'report.nature.behavior.4': '계절의 변화나 날씨, 지형 등 자연 현상에 민감하게 반응합니다.',
  'report.nature.behavior.5': '숲, 공원, 바다 등 자연 환경에서 에너지를 회복하고 즐거움을 느낍니다.',
  'report.nature.behavior.6': '자연과 관련된 책이나 다큐멘터리 시청을 좋아합니다.',
  'report.nature.behavior.7': '돌, 조개껍데기, 나뭇잎 등 자연물을 수집하고 분류하는 취미를 가집니다.',
  'report.nature.behavior.8': '환경 오염이나 멸종 위기 동물에 대해 걱정하고 실천하려 합니다.',
  'report.nature.behavior.9': '캠핑이나 등산 등 자연 속에서의 활동을 선호합니다.',
  'report.nature.behavior.10': '식물을 키우거나 텃밭 가꾸기 활동에 책임감을 보입니다.',
  'report.nature.support.1.title': '자연 탐사 기회 제공',
  'report.nature.support.1.desc': '주말마다 숲 체험, 식물원, 동물원 방문 등 자연을 직접 경험할 기회를 자주 만들어 주세요.',
  'report.nature.support.2.title': '반려 동식물 기르기',
  'report.nature.support.2.desc': '강아지, 고양이 또는 작은 화분을 직접 돌보며 생명에 대한 책임감과 공감 능력을 키우게 도와주세요.',
  'report.nature.support.3.title': '자연 관찰 일지',
  'report.nature.support.3.desc': '관심 있는 곤충이나 식물을 관찰하고 그림이나 글로 기록하는 활동을 권장해 주세요.',
  'report.nature.support.4.title': '환경 보호 교육',
  'report.nature.support.4.desc': '분리수거 하기, 에너지 절약하기 등 지구 환경을 지키는 작은 실천을 생활화하도록 지도해 주세요.',
  'report.nature.support.5.title': '자연물 예술 활동',
  'report.nature.support.5.desc': '조약돌 그림 그리기, 나뭇잎 콜라주 등 자연물을 활용한 창작 활동으로 감수성을 넓혀 주세요.',
  'report.nature.precautions': '자연친화 지능이 높은 아이는 현대 사회의 인공적이고 정적인 공간에서 답답함이나 스트레스를 더 크게 느낄 수 있습니다. 도시 환경에서도 정기적으로 자연을 접할 수 있는 시간을 확보해 주는 정서적 배려가 필요합니다. 또한 생명에 대한 과도한 몰입이 때로 타인과의 관계보다 동식물에만 집중되는 경향을 보일 수 있으므로, 생명을 소중히 여기는 마음을 사람에 대한 존중으로 확장해 나갈 수 있도록 도와주세요.',
};

export default ko;
